export const SET_USERS_LIST = "USER/SET_USERS_LIST";
export const SET_ROLES_LIST = "USER/SET_ROLES_LIST";